module.exports = {
  title: 'Mahender Redddy Pokala | AI Engineer',
  description:
    'Mahender Redddy Pokala is a Skilled ML Engineer with expertise in designing and developing computer vision and Large Language model systems. Professional in popular ML frameworks.',
  email: 'mahenderreddy.ai@gmail.com',
  siteKeywords:
    'Mahender Redddy Pokala, Mahender, Reddy, mahenderp, mahenderreddyp, mahender uchicago, mahender chicago, AI engineer, deep learning engineer, machine learning engineer, computer vision, bml munjal university, university of chicago, uchciago, flask, warangal, image processing, healthcare technologies, autonomo, phoenix ai, cehd, autonomo gmbh, adventum, scienaptic',
  siteUrl: 'https://mahenderp.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/mmsv',
    },
    {
      name: 'Gmail',
      url: 'mailto: mahenderreddy.ai@gmail.com',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/mahenderreddyp',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/venom__rules',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/Mmsv2549',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#9FFFCB',
    navy: '#231942',
    darkNavy: '#0D0221',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
